import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactPaginate from 'react-paginate';
import api from '../../../services/api';
import {
  Container, Filter, Table, Paginate,
} from './styles';

import Button from '../../../components/Button';
import Input from '../../../components/Input';
import Loading from '../../../components/Loading';
import Select from '../../../components/Select';

export default class Promoters extends Component {
  state = {
    alert: {},
    checkAll: false,
    checkedPromoters: [],
    events: [],
    selectedEventId: null,
    filterGenreOption: 'all',
    filterRatingOption: 0,
    filterPageOption: 20,
    total_pages: 0,
    loading: true,
    promoters: [],
    filterSize: 0,
    searchCityInput: '',
    searchFollowersInput: '',
    searchNameInput: '',
    filteredResults: [],
    showAlert: false,
  };

  filterGenreOptions = [
    { value: 'all', text: 'Todos' },
    { value: 'female', text: 'Feminino' },
    { value: 'male', text: 'Masculino' },
  ];

  filterRatingOptions = [
    { value: 0, text: '0' },
    { value: 1, text: '1' },
    { value: 2, text: '2' },
    { value: 3, text: '3' },
    { value: 4, text: '4' },
    { value: 5, text: '5' },
  ];

  filterPageOptions = [
    { value: 20, text: '20' },
    { value: 50, text: '50' },
    { value: 100, text: '100' },
    { value: 200, text: '200' },
    { value: 500, text: '500' },
    { value: 1000, text: '1000' },
    { value: 2000, text: '1000' },
    { value: 10000, text: '10000' },
  ];


  genreTranslation = {
    male: 'Masculino',
    female: 'Feminino',
  };

  componentDidMount() {
    this.loadPromoters(1);
    this.loadEvents();
  }

  loadPromoters = async (page = 1) => {
    const {
      filterGenreOption,filterPageOption, filterRatingOption, searchCityInput, searchNameInput, searchFollowersInput,
    } = this.state;
    let params = {
      approval_status: 'approved',
      results: filterPageOption,
      rating: filterRatingOption,
      fullname: searchNameInput,
      city: searchCityInput,
      followers: searchFollowersInput,
      page,
    };
    if (filterGenreOption !== 'all') {
      params = {
        ...params,
        genre: filterGenreOption,
      };
    }
    try {
      const { data } = await api.get('admin/promoters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
        params,
      });

      let { promoters } = data;

      promoters = promoters.map(promoter => ({
        ...promoter,
        translatedGenre: this.genreTranslation[promoter.genre],
      }));

      this.setState({
        promoters, filteredResults: promoters, filterSize: data.filter_size, total_pages: data.total_pages,
      });

      promoters.forEach((promoter) => {
        this.setState({
          [`followers-${promoter.id}`]: promoter.followers,
          [`engagement-${promoter.id}`]: promoter.engagement,
          [`instagram-${promoter.id}`]: promoter.instagram_username,
        });
      });

      this.setState({ loading: false });
    } catch (err) {
      this.setState({ promoters: [] });
    }
  };

  loadEvents = async () => {
    try {
      const { data } = await api.get('admin/events', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });

      const events = data.events
        .filter(event => event.status === 'active')
        .map(event => ({ value: event.id, text: event.name }));

      this.setState({
        events,
      });

      this.setState({ loading: false });
    } catch (err) {
      const { errors: messages } = err.response.data;
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  blockPromoter = async (id, status) => {
    const { promoters } = this.state;
    const formData = new FormData();
    formData.append('status', status);
    try {
      await api.put(`admin/promoters/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });

      const updatedPromoters = [...promoters];
      const index = updatedPromoters.findIndex(x => x.id === id);
      updatedPromoters[index].status = status;

      this.setState({ promoters: updatedPromoters });

      this.filterResults();
    } catch (err) {
      const messages = err.response
        ? err.response.data.errors
        : ['Não foi possível bloquear o divulgador. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  updatePromoter = async (id) => {
    const formData = new FormData();
    formData.append('engagement', this.state[`engagement-${id}`]);
    formData.append('followers', this.state[`followers-${id}`]);
    formData.append('instagram_username', this.state[`instagram-${id}`]);
    try {
      await api.put(`admin/promoters/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });

      this.setState(
        {
          alert: {
            title: 'Sucesso',
            type: 'success',
            messages: ['Divulgador atualizado com sucesso!'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    } catch (err) {
      const messages = err.response
        ? err.response.data.errors
        : ['Não foi possível aprovar o divulgador. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  };

  handleFilter = () =>{
    this.setState({ loading: true });
    this.loadPromoters(1);
  }

  handleChangeEdit = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  toggleAll = () => {
    const { checkAll, filteredResults } = this.state;

    if (checkAll) {
      this.setState({ checkedPromoters: [] });
    } else {
      this.setState({ checkedPromoters: filteredResults });
    }

    this.setState({ checkAll: !checkAll });
  };

  togglePromoter = (promoter) => {
    const { checkedPromoters } = this.state;

    if (checkedPromoters.includes(promoter)) {
      this.setState({ checkedPromoters: checkedPromoters.filter(p => p !== promoter) });
    } else {
      this.setState(prevState => ({
        checkedPromoters: [...prevState.checkedPromoters, promoter],
      }));
    }
  };

  handleInvite = () => {
    this.setState(
      {
        alert: {
          title: 'Tem certeza?',
          type: 'warning',
          messages: ['Todos os divulgadores selecionados serão convidados para este evento.'],
          confirmBtnText: 'Confirmar',
          showCancel: true,
          cancelBtnText: 'Não',
          cancelBtnBsStyle: 'info',
          onConfirm: this.confirmInvitePromoters,
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmInvitePromoters = async () => {
    this.closeAlert();

    const { checkedPromoters, selectedEventId, filteredResults } = this.state;
    const invitedPromoters = filteredResults.filter(promoter =>
      checkedPromoters.includes(promoter));
    const invitedPromotersIds = invitedPromoters.map(promoter => promoter.id);

    try {
      await api.post('admin/event_promoters', {
        event_promoter: {
          event_id: selectedEventId,
          invited_promoters_ids: invitedPromotersIds,
        },
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });
      this.setState(
        {
          alert: {
            title: 'Sucesso',
            type: 'success',
            messages: ['Divulgadores convidados com sucesso!'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    } catch (err) {
      this.setState({ loading: false });
      const messages = err.response && err.response.data && err.response.data.errors
        ? err.response.data.errors
        : ['Não foi possível convidar os divulgadores. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handlePageClick = (data) => {
    //this.setState({ loading: true });
    this.loadPromoters(data.selected + 1);
  };


  filterResults = () => {
    const {
      promoters,
      searchCityInput,
      searchNameInput,
      searchFollowersInput,
      filterGenreOption,
      filterRatingOption,
    } = this.state;

    let filteredResults = promoters;

    if (searchCityInput.length > 0) {
      filteredResults = filteredResults.filter(promoter =>
        promoter.city.toLowerCase().includes(searchCityInput.toLowerCase()));
    }
    if (searchNameInput.length > 0) {
      filteredResults = filteredResults.filter(promoter =>
        (promoter.name.toLowerCase().includes(searchNameInput.toLowerCase())
        || promoter.instagram_username.toLowerCase().includes(searchNameInput.toLowerCase())));
    }
    if (searchFollowersInput.length > 0) {
      filteredResults = filteredResults.filter(
        promoter => promoter.followers >= searchFollowersInput,
      );
    }
    if (filterGenreOption !== 'all') {
      filteredResults = filteredResults.filter(promoter => promoter.genre === filterGenreOption);
    }
    filteredResults = filteredResults.filter(promoter => promoter.rating >= filterRatingOption);
    this.setState({ filteredResults });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      checkAll,
      checkedPromoters,
      events,
      filterGenreOption,
      filterRatingOption,
      filterPageOption,
      filteredResults,
      filterSize,
      loading,
      total_pages,
      searchCityInput,
      searchFollowersInput,
      searchNameInput,
      selectedEventId,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <h1 className="page-title">Divulgadores aprovados ({filterSize})</h1>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  <div className="box-header">
                  <div className="filter">
                        <Input
                          name="searchNameInput"
                          onChange={this.handleChange}
                          placeholder="Nome ou @usuário"
                          value={searchNameInput}
                        />
                      </div>
                      <div className="filter">
                        <Input
                          name="searchCityInput"
                          onChange={this.handleChange}
                          placeholder="Cidade"
                          value={searchCityInput}
                        />
                      </div>
                      <div className="filter">
                        <Input
                          name="searchFollowersInput"
                          onChange={this.handleChange}
                          placeholder="Mín. de seguidores"
                          type="number"
                          value={searchFollowersInput}
                        />
                      </div>
                      <div className="filter">
                      <button className="btn btn-primary mt-2" onClick={()=>{this.handleFilter()}}>Filtrar</button>
                      </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="box-header">
                      
                      <div className="filter">
                        <Filter>
                          <span>Gênero:</span>
                          <Select
                            name="filterGenreOption"
                            onChange={this.handleChange}
                            options={this.filterGenreOptions}
                            value={filterGenreOption}
                          />
                        </Filter>
                      </div>
                      <div className="filter">
                        <Filter>
                          <span>Aval. mín</span>
                          <Select
                            name="filterRatingOption"
                            onChange={this.handleChange}
                            options={this.filterRatingOptions}
                            value={filterRatingOption}
                          />
                        </Filter>
                      </div>
                      <div className="filter">
                        <Filter>
                          <span>Páginas</span>
                          <Select
                            name="filterPageOption"
                            onChange={this.handleChange}
                            options={this.filterPageOptions}
                            value={filterPageOption}
                          />
                        </Filter>
                      </div>
                    </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  {checkedPromoters.length > 0 && (
                    <div className="invite-promoter-container">
                      <span className="subtitle">Convidar para evento:</span>
                      <Select
                        value={selectedEventId}
                        name="selectedEventId"
                        onChange={this.handleChange}
                        description="Selecione um evento"
                        options={events}
                      />
                      {selectedEventId && (
                        <Button className="btn-success invite-promoter" onClick={this.handleInvite}>
                          Convidar
                        </Button>
                      )}
                    </div>
                  )}
                  {filteredResults.length > 0 ? (
                    <div className="table-wrapper">
                      <Table className="table">
                        <thead>
                          <tr>
                            <th>
                              <input type="checkbox" checked={checkAll} onChange={this.toggleAll} />
                            </th>
                            <th>Nome</th>
                            <th>Gênero</th>
                            <th>Cidade</th>
                            <th>Instagram</th>
                            <th>Email</th>
                            <th>Telefone</th>
                            <th>Avaliação média</th>
                            <th>Nº de seguidores</th>
                            <th>Engajamento</th>
                            <th>Atualizar</th>
                            <th>Bloquear / Desbloquear</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredResults.map(promoter => (
                            <tr key={promoter.id}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={checkedPromoters.includes(promoter)}
                                  onChange={() => this.togglePromoter(promoter)}
                                />
                              </td>
                              <td>{promoter.name}</td>
                              <td>{promoter.translatedGenre}</td>
                              <td>{promoter.city}</td>
                              <td>
                                <Input
                                  name={`instagram-${promoter.id}`}
                                  value={this.state[`instagram-${promoter.id}`]}
                                  onChange={this.handleChangeEdit}
                                  className="instagram-input"
                                />
                              </td>
                              <td>{promoter.email}</td>
                              <td>{promoter.phone}</td>
                              <td>{promoter.rating}</td>
                              <td>
                                <Input
                                  name={`followers-${promoter.id}`}
                                  value={this.state[`followers-${promoter.id}`]}
                                  onChange={this.handleChangeEdit}
                                  className="followers-input"
                                />
                              </td>
                              <td>
                                <Input
                                  name={`engagement-${promoter.id}`}
                                  value={this.state[`engagement-${promoter.id}`]}
                                  onChange={this.handleChangeEdit}
                                />
                              </td>
                              <td>
                                <Button
                                  onClick={() => this.updatePromoter(promoter.id)}
                                  className="btn-success btn-small"
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                </Button>
                              </td>
                              <td>
                                {promoter.status === 'active' ? (
                                  <Button
                                    onClick={() => this.blockPromoter(promoter.id, 'blocked')}
                                    className="btn-outline-danger btn-small"
                                  >
                                    Bloquear
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() => this.blockPromoter(promoter.id, 'active')}
                                    className="btn-outline-success btn-small"
                                  >
                                    Desbloquear
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <Paginate>
                        <ReactPaginate
                          previousLabel="Anterior"
                          nextLabel="Próximo"
                          breakLabel="..."
                          breakClassName="break-me"
                          pageCount={total_pages}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={this.handlePageClick}
                          containerClassName="pagination"
                          subContainerClassName="pages pagination"
                          activeClassName="active"
                        />
                      </Paginate>
                    </div>
                  ) : (
                    <h5 className="text-center">
                      Não existem divulgadores com os filtros selecionados.
                    </h5>
                  )}
                </div>
              </div>
            </div>
            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/Promoters/index.js